export interface IupdateUserDetailsRes {
  responseMessage: string,
  successFlag: 0
}
